import { render, staticRenderFns } from "./Svglegend.vue?vue&type=template&id=6cc5e25e&scoped=true"
import script from "./Svglegend.vue?vue&type=script&lang=js"
export * from "./Svglegend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cc5e25e",
  null
  
)

export default component.exports